export default "<ng-template cdkPortalOutlet></ng-template>\n"